"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
const ValidatedField_1 = require("./ValidatedField");
/**
 * Represents a single field in a {@link Form}
 * @class
 */
class Field extends ValidatedField_1.ValidatedField {
    /**
     * Creates a new field instance
     * @param name This field's name (unique value identifier, not label)
     * @param defaultValue Default value to use initially and on reset
     * @param form The parent form for this field
     */
    constructor(name, defaultValue, form) {
        const getForm = () => form;
        const validationFunctions = form.getFieldValidationFunctions(name);
        const onUpdate = () => form.announceFieldUpdate(name);
        super(name, defaultValue, getForm, validationFunctions, onUpdate);
    }
    /** Store the provided ref on the field */
    setRef(ref) {
        this._ref = ref;
    }
    /** Retrieve the stored ref as a certain type */
    getRef() {
        return this._ref;
    }
    /** Reset the field and announce update */
    reset() {
        // reset() is a function that might be passed around, e.g. onClick={field.reset}
        // don't want to bind function to every field but want a more descriptive error
        if (!this) {
            throw new Error("reset() is unbound, try (() => field.reset())");
        }
        // do actual reset
        super.reset();
    }
}
exports.Field = Field;
